import {assign} from '../../../../lib/assign';
import {createReducer, on} from '@ngrx/store';
import {editManyDefinitionLoadComplete, editManyDefinitionLoadStart} from './edit-many-definitions.actions';
import {EditManyDefinitionsState} from './edit-many-definitions.model';

const INITIAL_STATE: EditManyDefinitionsState = {
    isFetching: false,
    definitionsByType: {}
};

export const editManyDefinitionsReducer = createReducer(
    INITIAL_STATE,
    on(editManyDefinitionLoadStart, (state) => assign(state, {isFetching: true})),
    on(editManyDefinitionLoadComplete, (state, {definition}) => {
        return {
            isFetching: false,
            definitionsByType: assign(state.definitionsByType, definition)
        };
    })
);